import * as yup from 'yup';

import errorText from './validationTexts';

export const loanCompletionDetails = yup.object().shape({
    email: yup.lazy((value) => {
        if (value !== undefined) {
            return yup.string().trim().email(errorText.emailInvalid).required(errorText.emailRequired);
        }
        return yup.mixed().notRequired();
    }),

    phone: yup.lazy((value) => {
        if (value !== undefined) {
            return yup
                .string()
                .trim()
                .typeError(errorText.phoneLength)
                .min(8, errorText.phoneLength)
                .max(8, errorText.phoneLength)
                .length(8, errorText.phoneLength)
                .required(errorText.phoneLength);
        }
        return yup.mixed().notRequired();
    }),
});

export default { loanCompletionDetails };
